import {
  storyblokEditable,
  StoryblokComponent,
  SbBlokData,
} from "@storyblok/react"
import { Fragment } from "react"
import type { ReactNode } from "react"

export interface IPage extends SbBlokData {
  body: Array<SbBlokData>
}

// Stories end with a footer blok, so anything appended after the body renders
// below the footer. Sections injected from getStaticProps go in front of the
// first of these instead.
const FOOTER_COMPONENTS = new Set(["footer", "PremiumFooter", "ProductFooter"])

export interface IPageProps {
  blok: IPage
  /**
   * Server-rendered section injected between the story body and its footer.
   * Used for content the CMS cannot express because it needs server data — the
   * Senja testimonial section and the review-segment reciprocal link. Appended
   * at the end when a story has no footer blok.
   */
  beforeFooter?: ReactNode
}

const Page = ({ blok, beforeFooter }: IPageProps) => {
  const footerIndex = beforeFooter
    ? blok.body.findIndex((nestedBlok) =>
        FOOTER_COMPONENTS.has(String(nestedBlok.component)),
      )
    : -1
  const injectAt = footerIndex === -1 ? blok.body.length : footerIndex

  return (
    <main
      {...storyblokEditable(blok)}
      data-testid="test-font"
      className={blok.font ? `font-all-${blok.font}` : undefined}
    >
      {blok.body.map((nestedBlok, index) => (
        <Fragment key={nestedBlok._uid}>
          {beforeFooter && index === injectAt ? beforeFooter : null}
          <StoryblokComponent blok={nestedBlok} />
        </Fragment>
      ))}
      {beforeFooter && injectAt === blok.body.length ? beforeFooter : null}
    </main>
  )
}

export default Page
